import { render } from "./Popup.vue?vue&type=template&id=0831a8e7&scoped=true&ts=true"
import script from "./Popup.ts?vue&type=script&lang=ts&external"
export * from "./Popup.ts?vue&type=script&lang=ts&external"

import "./Popup.vue?vue&type=style&index=0&id=0831a8e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0831a8e7"]])

export default __exports__